import { Button, Card, Tooltip } from "@/components/ui";
import * as React from "react";
import { kFormatter } from "@/utils";
import { BarChart3 } from "lucide-react";
import { averageTooltip } from "../averageCopy";

interface Props {
  title: string;
  total?: number | null;
  average?: number | null;
  /** How many posts the average is taken over; shown on hover. */
  reportingCount?: number;
  onShowMore?: () => void;
  icon: React.ReactNode;
}

export function StatCard({ title, total, average, reportingCount, onShowMore, icon }: Props) {
  const averageLine = (
    <div className="flex items-center gap-1.5 mt-2">
      <span className="font-semibold text-slate-600">{kFormatter(average || 0)}</span>
      <span className="text-sm text-slate-400 font-medium">avg. per post</span>
    </div>
  );
  return (
    <>
      <Card size="sm" className="flex-1 shadow-sm border-slate-200">
        <Card.Header className="pb-0 border-b-0 space-y-0">
          <Card.Title className="flex flex-row gap-2 items-center text-sm font-semibold uppercase tracking-widest text-slate-400">
            <div className="text-slate-400">{icon}</div>
            {title}
          </Card.Title>
        </Card.Header>
        <Card.Content>
          <div className="flex flex-col gap-2">
            <div className="text-3xl font-bold text-slate-900 tracking-tight leading-none">
              {kFormatter(total || 0)}
            </div>
            {onShowMore ? (
              <Button variant="ghost" onClick={onShowMore}>
                <BarChart3 /> View More Stats
              </Button>
            ) : reportingCount !== undefined ? (
              <Tooltip>
                <Tooltip.Trigger render={<div className="w-fit cursor-help" />}>{averageLine}</Tooltip.Trigger>
                <Tooltip.Content>{averageTooltip(title, reportingCount)}</Tooltip.Content>
              </Tooltip>
            ) : (
              averageLine
            )}
          </div>
        </Card.Content>
      </Card>
    </>
  );
}
